module.exports = __webpack_public_path__ + "img/SA-1920.4854d0fd.jpg";